<template>
    <SectionTemplate :section-data="props.sectionData">
        <!-- About Item -->
        <div v-for="item in props.sectionData['items']" class="about-item">
            <!-- Image Column -->
            <div class="col-image">
                <ImageView :src="item['imageUrl']" :alt="'Parker Wieseler portrait'" class="img"/>
            </div>

            <!-- Texts Column -->
            <div class="col-texts">
                <p v-for="paragraph in item['description']" class="text-4" v-html="paragraph"/>
            </div>
        </div>
    </SectionTemplate>
</template>

<script setup>
import SectionTemplate from "./templates/SectionTemplate.vue"
import ImageView from "../widgets/ImageView.vue"

/**
 * @property {Object} sectionData
 */
const props = defineProps({
    sectionData: Object
})
</script>

<style lang="scss" scoped>
@import "/src/scss/_theming.scss";

.about-item {
    display: flex;
    flex-direction: row;
    width: 100%;

    @include media-breakpoint-down(lg) {
        flex-direction: column;
    }
}

.col-image {
    @include generate-dynamic-styles-with-hash((
        xxxl: (width: min(30vw, 360px), margin-right: 4rem),
        xxl:  (width: min(33vw, 300px), margin-right: 3.5rem),
        lg:   (width: min(70vw, 320px), margin-right: 0, margin-bottom: 2rem)
    ));

    display: flex;
}

.col-image, .col-texts {
    align-self: center;
    text-align: justify;

    @include media-breakpoint-down(lg) {
        text-align: left;
    }
}

.img {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
    border-radius: 20px;
    overflow: hidden;

    :deep(.image-view-img) {
        width: 100%;
        height: auto;
        object-fit: contain;
        object-position: center center;
    }
}
</style>